import React from 'react';

import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import ArtListProvider from './contexts/ArtListProvider';
import EventListProvider from './contexts/EventListProvider';
import SiteConfigProvider from './contexts/SiteConfigProvider';
import AdminPage from './pages/AdminPage';
import ArtDetailPage from './pages/ArtDetailPage';
import ContactPage from './pages/ContactPage';
import EventDetailPage from './pages/EventDetailPage';
import EventsPage from './pages/EventsPage';
import HomePage from './pages/HomePage';

const App: React.FC = () => {
  return (
    <SiteConfigProvider>
      <ArtListProvider>
        <EventListProvider>
          <Router>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/art/:id" element={<ArtDetailPage />} />
              <Route path="/events" element={<EventsPage />} />
              <Route path="/events/:id" element={<EventDetailPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/admin" element={<AdminPage />} />
            </Routes>
          </Router>
        </EventListProvider>
      </ArtListProvider>
    </SiteConfigProvider>
  );
};

export default App;